import React from 'react';
import './WebSocketStatus.css';

function WebSocketStatus({ status }) {
  const getStatusInfo = () => {
    switch (status) {
      case 'connected':
        return { text: 'Connected', className: 'status-connected' };
      case 'connecting':
        return { text: 'Connecting...', className: 'status-connecting' };
      case 'disconnected':
        return { text: 'Disconnected', className: 'status-disconnected' };
      case 'error':
        return { text: 'Error', className: 'status-error' };
      default:
        return { text: 'Unknown', className: 'status-unknown' };
    }
  };

  const statusInfo = getStatusInfo();

  return (
    <div className={`websocket-status ${statusInfo.className}`}>
      <span className="status-indicator"></span>
      <span className="status-text">{statusInfo.text}</span>
    </div>
  );
}

export default WebSocketStatus;